import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridRow, GridColumn } from "arv-reactcomponents";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";

import ReversePickUp from "../ReversePickUp";
import SelfShip from "../SelfShip";
import NextButton from "../../NextButton";
import BackButton from "../../BackButton";
import { RETURNS } from "npmlinks-constants";

const { RETURN_MODES, RETURN_REASONS } = RETURNS;

@inject("AddressStore", "ReturnStore")
@observer
class ReturnModes extends Component {
  constructor(props) {
    super(props);
    this.getSelectedMethod = this.getSelectedMethod.bind(this);
    this.setReversePickAddress = this.setReversePickAddress.bind(this);
    this.setSelectedMethod = this.setSelectedMethod.bind(this);
  }

  componentDidMount() {
    const { deliveredAddressId } = this.props;
    if (!this.props.ReturnStore.selectedReturnAddressId) {
      this.setReversePickAddress(deliveredAddressId);
    }
  }

  getSelectedMethod(option) {
    return this.props.ReturnStore.selectedReturnMode === option;
  }

  setSelectedMethod(option) {
    this.props.ReturnStore.setReturnMode(option);
  }

  setReversePickAddress(addressId) {
    this.props.ReturnStore.setReturnAddressId(addressId);
  }

  get getReversePickAddress() {
    const addressList = toJS(this.props.AddressStore.userAddresses);
    const selectedAddressId = this.props.ReturnStore.selectedReturnAddressId;
    return addressList.find(address => address.id === selectedAddressId);
  }

  get returnModes() {
    return this.props.ReturnStore.returnModes;
  }

  get selfShipAddress() {
    return this.props.ReturnStore.selfShipInfo;
  }

  get shouldEnableNextButton() {
    const retrunMode = this.props.ReturnStore.selectedReturnMode;
    const returnId = this.getReversePickAddress;
    const isReturnable = returnId && returnId.isReturnable;
    if ((retrunMode === RETURN_MODES.REVERSEPICKUP && !returnId) || (retrunMode === RETURN_MODES.REVERSEPICKUP && !isReturnable)) {
      return false;
    }
    return true;
  }

  selectView(option) {
    const returnModeDetails = this.returnModes.find(
      item => item.name === option,
    );
    switch (option) {
      case RETURN_MODES.REVERSEPICKUP:
        return (
          <ReversePickUp.component
            address={this.getReversePickAddress}
            data={returnModeDetails}
            inner={this.props.inner}
            onChecked={this.getSelectedMethod(RETURN_MODES.REVERSEPICKUP)}
            onSelection={this.setSelectedMethod}
          />
        );
      case RETURN_MODES.SELFSHIP:
        return (
          <SelfShip.component
            address={this.selfShipAddress.addressDetails}
            data={returnModeDetails}
            onChecked={this.getSelectedMethod(RETURN_MODES.SELFSHIP)}
            onSelection={this.setSelectedMethod}
          />
        );
      default:
        return (
          <ReversePickUp.component
            address={this.getReversePickAddress}
            data={returnModeDetails}
            inner={this.props.inner}
            onChecked={this.getSelectedMethod(RETURN_MODES.REVERSEPICKUP)}
            onSelection={this.setSelectedMethod}
          />
        );
    }
  }

  render() {
    return (
      <GridRow className="nw-returnmodes-container">
        <GridColumn>
          <BackButton.component
            previous={this.props.previous}
            className="nw-returns-backbtn"
          />
          <h2 className="nw-returnmodes-title"> {RETURN_REASONS.TITLE} </h2>
          <div className="nw-returnmodes-wrapper">
            <form>
              {this.returnModes
                .reverse()
                .map(item => this.selectView(item.name))}
            </form>
          </div>
        </GridColumn>
        <NextButton.component
          className="nw-returns-nxtbtn"
          next={this.props.next}
          disabled={!this.shouldEnableNextButton}
        />
      </GridRow>
    );
  }
}

ReturnModes.defaultProps = {
  deliveredAddressId: "",
  inner: PropTypes.func,
  next: PropTypes.func,
  previous: PropTypes.func,
};

ReturnModes.wrappedComponent.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  deliveredAddressId: PropTypes.string,
  inner: PropTypes.func,
  ReturnStore: PropTypes.shape({
    returnModes: PropTypes.array.isRequired,
    selectedReturnMode: PropTypes.string,
    selfShipAddress: PropTypes.shape({}).isRequired,
    setReturnMode: PropTypes.func,
    selfShipInfo: PropTypes.shape({
      addressDetails: PropTypes.shape({}).isRequired,
    }).isRequired,
    selectedReturnAddressId: PropTypes.string,
    setReturnAddressId: PropTypes.func,
  }).isRequired,
  AddressStore: PropTypes.shape({
    userAddresses: PropTypes.shape({}),
  }).isRequired,
};

const getFinalComponent = component =>
  inject("AddressStore", "ReturnStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReturnModes.wrappedComponent,
  component: ReturnModes,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/ReturnModes/index.js